import {
        AddOn,
        AddOnPlan,
        AddOnStatus,
        AddOnType,
        Asset,
        BillingCycle,
        Currency,
        HighlightFeature,
        Price,
        SettingsConfig,
        SettingsConfigType,
        UsageStats,
        UsageStatsType,
} from "../../../../index";
import plutioProvider from "../../providers/prod/plutio";

const a010AddOn = new AddOn({
	internalId: "a010",
	externalId: "pro_stage_a010_plutio_secrets_manager",
	shortName: "Secrets manager",
	longName: "Plutio Secrets Manager",
	shortDescription: "Managed secrets vault tailored for Plutio automations.",
	longDescription:
		"Provision a dedicated secrets manager on Google Cloud that keeps your Plutio API keys, OAuth credentials, and webhook tokens encrypted, versioned, and automatically rotated.",
	type: AddOnType.SERVICE,
	iconAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/a009/icons/a009_icon_rounded.png"
	),
	coverAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/background1.png"
	),
	previewAssets: [
		Asset.image(
			"https://storage.googleapis.com/cdn.version2.io/add-ons/a009/screenshots/a009_screenshot_1.png"
		),
		Asset.image(
			"https://storage.googleapis.com/cdn.version2.io/add-ons/a009/screenshots/a009_screenshot_2.png"
		),
	],
	docsUrl: "https://docs.version2.io/articles/assets-generator-bae920-829dc",
	providersIds: [plutioProvider._.id],
	status: AddOnStatus.IN_REVIEW,
	plans: [
		new AddOnPlan({
			billingCycle: BillingCycle.yearly(),
			internalId: "a010_p001",
			externalId: "pri_stage_a010_yearly",
			prices: [new Price({ currency: Currency.USD, amount: 108 })],
		}),
		new AddOnPlan({
			billingCycle: BillingCycle.monthly(),
			internalId: "a010_p002",
			externalId: "pri_stage_a010_monthly",
			prices: [new Price({ currency: Currency.USD, amount: 12 })],
		}),
	],
	usageStats: [
		new UsageStats({
			id: "stored_secrets",
			name: "Stored secrets",
			description: "Number of encrypted secrets stored for this workspace.",
			type: UsageStatsType.DOCUMENTS,
			max: 2000,
		}),
		new UsageStats({
			id: "api_requests",
			name: "API requests",
			description: "Monthly API requests to the hosted secrets manager.",
			type: UsageStatsType.REQUESTS,
		}),
	],
	settingsConfig: [
		new SettingsConfig({
			id: "plutio_workspace",
			label: "Plutio workspace",
			description: "Select the Plutio workspace that will consume the secrets.",
			type: SettingsConfigType.INTEGRATION,
			validators: "plutio",
			required: true,
		}),
		new SettingsConfig({
			id: "service_account",
			label: "Google service account (JSON)",
			description:
				"Upload a Google service account JSON key with access to the hosted secrets manager Cloud Run service.",
			type: SettingsConfigType.KEY,
			encrypted: true,
			required: true,
		}),
		new SettingsConfig({
			id: "namespace",
			label: "Secrets namespace",
			description: "Prefix applied to secrets created from this workspace.",
			type: SettingsConfigType.STRING,
			default_value: "plutio",
			required: true,
		}),
		new SettingsConfig({
			id: "rotation_interval",
			label: "Rotation interval (days)",
			description: "How frequently stored secrets should be rotated automatically.",
			type: SettingsConfigType.INT,
			default_value: 30,
		}),
	],
	highlightFeatures: [
		new HighlightFeature({
			title: "Hosted secrets vault",
			description: "Dedicated secrets infrastructure deployed on Google Cloud with zero maintenance overhead.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/shield-check.svg",
		}),
		new HighlightFeature({
			title: "Automated rotation",
			description: "Secrets are rotated automatically through a configurable Cloud Scheduler policy.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/repeat.svg",
		}),
		new HighlightFeature({
			title: "Embed in Plutio",
			description: "Drop secrets directly into Plutio automations through pre-built embeds and widgets.",
			icon: "https://storage.googleapis.com/cdn.version2.io/icons/layout.svg",
		}),
	],
});

export default a010AddOn;
